import { lazy } from "react";

export const LandingSeventhScreenAsync = lazy(() => import("./LandingSeventhScreen"));
